$(document).ready(function(){
  $('.slider-view').slick({
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true
  });
  $('.slider-description').slick({
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1200,
    dots: true
  });
  $('.video_container').on('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    var left = ($(window).width() - $('.play_video').width()) / 2;
    var top = ($(window).height() - $('.play_video').height()) / 2;
    $('.play_video').css({top: top + 'px', left: left + 'px'});
    $('.play_video').show();
    $('.overlay').show();
  });
  $('.overlay').on('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    $('.play_video').hide();
    $('iframe').attr('src', $('iframe').attr('src'))
    $('.overlay').fadeOut("slow", "swing");
  });
  $('.slide-nav').on('click', function(e){
    if(!$(this).hasClass("active-slide")){
      index = $(this).attr('class').match(/icon-[0-9]/)[0].match(/[0-9]/)[0];
      $("li button:contains("+index+")")[0].click();
      $("li button:contains("+index+")")[1].click();
    }
  });
});
